export var ConnectionNames;
(function (ConnectionNames) {
    ConnectionNames["sports"] = "SportsbookConnection";
    ConnectionNames["betslip"] = "BetSlipConnection";
})(ConnectionNames || (ConnectionNames = {}));
//# sourceMappingURL=index.js.map